export default __webpack_public_path__ + "static/media/renuma-plus-06.6bd1f47d.png";